var _rect, _path, _rect2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame40916(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 61,
    viewBox: "0 0 129 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 59.6942,
    y: 59.6942,
    width: 59.1946,
    height: 59.1946,
    rx: 29.5773,
    transform: "rotate(-180 59.6942 59.6942)",
    stroke: "#FFFAE6",
    strokeWidth: 1.00423
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6098 29.0228H38.6977V31.1728L25.6098 31.1728L31.6297 37.1927L30.0978 38.6977L21.498 30.0978L30.0978 21.498L31.6297 23.0029L25.6098 29.0228Z",
    fill: "#FFFAE6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 69.2979,
    y: 0.502115,
    width: 59.1946,
    height: 59.1946,
    rx: 29.5773,
    stroke: "#FFFAE6",
    strokeWidth: 1.00423
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.382 31.1735H90.2945V29.0236H103.382L97.3625 23.0037L98.8944 21.4987L107.494 30.0985L98.8944 38.6984L97.3625 37.1934L103.382 31.1735Z",
    fill: "#FFFAE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame40916);
export default __webpack_public_path__ + "static/media/frame-40916.06a0a908bef1e585f581c42bd2b604f9.svg";
export { ForwardRef as ReactComponent };